import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlMfaClient";
import { getClientId } from "../../utils/config";
import { wrapQuery } from "../../utils/wrapQuery";
export { sendAppMfaCode };
var sendAppMfaCodeMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation SendAppMfaCode($mfaToken: String!, $userUuid: String!, $clientId: NonEmptyString!) {\n    sendAppMfaCode(mfaToken: $mfaToken, userUuid: $userUuid, clientId: $clientId) {\n      status\n      qrLink\n    }\n  }\n"])));
async function sendAppMfaCode(mfaToken, userUuid) {
  var data = await wrapQuery('sendAppMfaCode', sendAppMfaCodeMutation, {
    mfaToken: mfaToken,
    userUuid: userUuid,
    clientId: getClientId()
  });
  return data.sendAppMfaCode;
}